import React, { ReactNode, useCallback } from "react";
import { connect } from "react-redux";

import { useIntl } from "react-intl";

import LeadFinderSubscriptionPlan from "@mapmycustomers/shared/enum/LeadFinderSubscriptionPlan";
import { Alert } from "@mapmycustomers/ui";

import ButtonLink from "@app/component/ButtonLink";
import { getLeadGenPlan, isCurrentUserOwner } from "@app/store/iam";
import { RootState } from "@app/store/rootReducer";
import useAnalytics from "@app/util/contexts/useAnalytics";
import showLeadFinderUpsell from "@app/util/leadFinder/showLeadFinderUpsell";

import styles from "./BasicPlanBanner.module.scss";

interface Props {
  isOwner: boolean;
  leadGenPlan?: LeadFinderSubscriptionPlan;
}

const BasicPlanBanner = ({ isOwner, leadGenPlan }: Props) => {
  const analytics = useAnalytics();
  const intl = useIntl();

  const handleClick = useCallback(() => {
    showLeadFinderUpsell(leadGenPlan, intl, isOwner);
    analytics.clicked(["Get more monthly searches by upgrading"]);
  }, [analytics, intl, isOwner, leadGenPlan]);

  return (
    <Alert
      className={styles.container}
      closable
      message={intl.formatMessage(
        {
          id: "leadFinder.basicPlanBanner.banner",
          defaultMessage: "Get more monthly searches by <a>upgrading Lead Finder</a>",
          description: "Lead Finder new plans banner",
        },
        {
          a: (text: ReactNode) => <ButtonLink onClick={handleClick}>{text}</ButtonLink>,
        }
      )}
    />
  );
};

const mapStateToProps = (state: RootState) => ({
  isOwner: isCurrentUserOwner(state),
  leadGenPlan: getLeadGenPlan(state),
});

export default connect(mapStateToProps)(BasicPlanBanner);
